import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface TestUser {
  id: string;
  oid: string;
  name: string;
  email: string;
  roles: string[];
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class TestUserCatalogService {
  private currentUserSubject = new BehaviorSubject<TestUser | null>(null);
  public currentUser$ = this.currentUserSubject.asObservable();

  private readonly testUsers: TestUser[] = [
    {
      id: 'admin',
      oid: 'd60d888a-5bcb-4d3d-b081-401c0dbfdedd',
      name: 'Automation Admin',
      email: 'admin@quidelortho.com',
      roles: [
        'LabPartner.Administrators',
        'LabPartner.Writers',
        'LabPartner.Readers',
        'ResultsBundler.ClinicalTrials',
        'LabPartner.Viewers',
      ],
      description: 'Full access to all features',
    },
    {
      id: 'writer',
      oid: 'a60d888a-5bcb-4d3d-b081-401c0dbfdedd',
      name: 'Automation Writer',
      email: 'writer@quidelortho.com',
      roles: ['LabPartner.Writers', 'LabPartner.Readers', 'LabPartner.Viewers'],
      description: 'Can create and edit experiments',
    },
    {
      id: 'reader',
      oid: 'b60d888a-5bcb-4d3d-b081-401c0dbfdedd',
      name: 'Automation Reader',
      email: 'reader@quidelortho.com',
      roles: ['LabPartner.Readers', 'LabPartner.Viewers'],
      description: 'Read-only access to experiments',
    },
  ];

  constructor() {}

  getTestUsers(): TestUser[] {
    return this.testUsers;
  }

  getTestUserById(id: string): TestUser | undefined {
    return this.testUsers.find(user => user.id === id);
  }

  setCurrentUser(user: TestUser): void {
    this.currentUserSubject.next(user);
  }

  getCurrentUser(): TestUser | null {
    return this.currentUserSubject.value;
  }

  clearCurrentUser(): void {
    this.currentUserSubject.next(null);
  }
}
